module.exports = __webpack_public_path__ + "static/media/Leah DeCesare Headshot_1698869424795.e70c7fd2.jpeg";